if (!customElements.get("lsg-carousel-rebuild")) customElements.define("lsg-carousel-rebuild", class LSGCarouselRebuild extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            carouselSectionEls: ".lsg-carousel-rebuild"
        };
        this.carouselSectionEls = this.querySelectorAll(this.selectors.carouselSectionEls);
        this.init();
    }
    init() {
        this.carouselSectionEls.forEach((carouselSectionEl)=>{
            buildCarousel(carouselSectionEl);
        });
        function buildCarousel(carouselSectionEl) {
            const sectionId = carouselSectionEl.getAttribute(`data-section-id`), carouselSettings = JSON.parse(document.getElementById(`CarouselSettings-${sectionId}`).textContent), carouselActualEl = carouselSectionEl.querySelector(`[lsg-carousel]`);
            const videoCards = carouselSectionEl.querySelectorAll('[lsg-carousel-video-card]');
            let carouselEl;
            if (carouselActualEl) {
                let carouselNavEl = carouselSectionEl.querySelector(`[lsg-carousel-nav]`), navPrevEl = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`), navDotsEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`), navDotEls = carouselNavEl.querySelectorAll(`[lsg-carousel-nav-dot]`), navNextEl = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
                function initCarousel(element, settings) {
                    // Non-customizable settings
                    settings.prevNextButtons = false // custom
                    ;
                    // settings.pageDots = false // custom
                    settings.percentPosition = false;
                    settings.imagesLoaded = true
                    settings.on = {
                        change: (index)=>{
                            updateNav(index);
                        }
                    };
                    carouselEl = new window.Flickity(element, settings);
                    carouselEl.on('dragStart', () => {
                        carouselEl.slider.style.pointerEvents = 'none';
                    });
                    carouselEl.on('dragEnd', () => {
                        carouselEl.slider.style.pointerEvents = '';
                    });

                    carouselEl.on(`settle`, (e) => {
                        widthChecker();
                        setSliderHeightToMax(carouselEl);
                    });
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 100);

                }
                initCarousel(carouselActualEl, carouselSettings);
                initNav(carouselSectionEl, carouselSettings);
                /* Width Checker */ function widthChecker() {
                    if (carouselEl && carouselActualEl.clientWidth > carouselEl.slideableWidth) {
                        carouselEl.cells.forEach((cell)=>cell.element.style.height = "");
                        carouselEl.destroy();
                    } else if (!carouselEl || !carouselEl.isActive) carouselEl = new window.Flickity(carouselActualEl, carouselSettings);
                }
                /* Height Handler */ function setSliderHeightToMax(carouselEl) {
                    carouselEl.cells.forEach((cell)=>cell.element.style.height = "");
                    let heights = carouselEl.cells.map((cell)=>cell.element.offsetHeight), max = Math.max.apply(Math, heights);
                    carouselEl.cells.forEach((cell)=>cell.element.style.height = max + "px");
                }
                /* Resize Handling */ window.addEventListener("resize", ()=>{
                    carouselEl.resize();
                    widthChecker();
                    setSliderHeightToMax(carouselEl);
                });
                /* Nav Handling */ function initNav(element, settings) {
                    carouselNavEl = element.querySelector(`[lsg-carousel-nav]`);
                    navPrevEl = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`);
                    navDotsEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`);
                    navDotEls = carouselNavEl.querySelectorAll(`[lsg-carousel-nav-dot]`);
                    navNextEl = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
                    updateNav(settings.initialIndex);
                }
                function updateNav(index) {
                    navDotEls.forEach((navDotEl)=>{
                        navDotEl.parentElement.classList.remove(`lsg-dot-selected`);
                    });
                    const currentNavDotEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dot-index="${index}"]`);
                    if (currentNavDotEl) currentNavDotEl.parentElement.classList.add(`lsg-dot-selected`);
                    if (navPrevEl && navNextEl) {
                        navPrevEl.removeAttribute(`disabled`);
                        navNextEl.removeAttribute(`disabled`);
                        if (!carouselEl?.isWrapping && index === 0) navPrevEl.setAttribute(`disabled`, true);
                        else if (!carouselEl?.isWrapping && index === carouselEl?.cells.length - 1) navNextEl.setAttribute(`disabled`, true);
                    }
                }
                if (navPrevEl && navNextEl) {
                    navPrevEl.addEventListener(`click`, (e)=>{
                        console.log("click")
                        carouselEl.previous();
                    });
                    navNextEl.addEventListener(`click`, (e)=>{
                        carouselEl.next();
                    });
                }
                navDotEls.forEach((navDotEl)=>{
                    navDotEl.addEventListener(`click`, (e)=>{
                        const index = navDotEl.getAttribute(`lsg-carousel-nav-dot-index`);
                        carouselEl.select(index);
                    });
                });
            }
            videoCards.forEach(videoCard => {
                const videoTriggers = videoCard.querySelectorAll('[lsg-carousel-video-trigger]');
                const videoEl = videoCard.querySelector('video');
                if (videoEl) {
                    videoEl.addEventListener('play', () => {
                        videoCards.forEach(card => {
                            const cardVideo = card.querySelector('video');
                            const cardVideoAuto = cardVideo.getAttribute(`autoplay`);
                            if (cardVideo && cardVideo != videoEl) {
                                cardVideo.muted = true;
                            }
                            if (cardVideo && cardVideo != videoEl && !cardVideoAuto) {
                                cardVideo.pause();
                            }
                        });
                    });
                    
                    const videoElAuto = videoEl.getAttribute(`autoplay`);
                    if (videoElAuto) {
                      videoEl.addEventListener('click', () => {
                        videoEl.muted = !videoEl.muted;
                        videoCards.forEach(card => {
                            const cardVideo = card.querySelector('video');
                            // const cardVideoAuto = cardVideo.getAttribute(`autoplay`);
                            if (cardVideo && cardVideo != videoEl) {
                                cardVideo.muted = true;
                            }
                        });
                      });
                    }

                    videoTriggers.forEach(trigger => {
                        trigger.addEventListener('click', (e) => {
                            videoCard.classList.add('video--played');
                            videoEl.controls = true;
                            videoEl.muted = false;
                            videoEl.play();
                        });
                    });
                }
            });
        }

    }
});
